import * as React from "react";
import { FunctionComponent } from "react";

interface CommonModalHeaderControlsProps {
    close?: boolean;
    onClose?: () => void;
    help?: boolean;
    onHelp?: () => void;
}

const CommonModalHeaderControls: FunctionComponent<CommonModalHeaderControlsProps> = props => {
    const helpButton = props.help ? (
        <button type="button" className="header-control" onClick={props?.onHelp}>
            <i className="ips-icon ips-icon-help" />
        </button>
    ) : null;

    const closeButton = props.close ? (
        <button
            type="button"
            className="header-control"
            data-testid="modal-header-close-button"
            onClick={props?.onClose}
        >
            <i className="ips-icon ips-icon-close" />
        </button>
    ) : null;

    return (
        <div className="modal-controls">
            {helpButton}
            {closeButton}
        </div>
    );
};

export default CommonModalHeaderControls;
